import { useEffect } from 'react';
import { useIntercom as useIntercomHandler } from 'react-use-intercom';
import util from 'utils/utils';

export const useIntercom = (user, history) => {
  const { boot: bootIntercom, update: updateIntercom, shutdown: shutdownIntercom } = useIntercomHandler();

  useEffect(() => {
    updateIntercom();
  }, [history, updateIntercom]);

  useEffect(() => {
    if (user && !util.organisationFeaturesEnabled(user, ['disableIntercom'])) {
      bootIntercom({
        customAttributes: {
          user_id: user._id,
          email: user.emails?.length && user.emails[0]?.address,
          name: user.profile && user.profile.fullName,
          organisationName: user.organisation?.name,
          canCreateChallenges: util.canCreateChallenges(user),
          canCreateExternalChallenges: util.canCreateChallenges(user) && util.organisationFeaturesEnabled(user, ['createExternalChallenges']),
          canReceiveExternalChallenges: util.organisationFeaturesEnabled(user, ['receiveExternalChallenges']),
          isOrgAdmin: util.isInRole(user, 'org.viewDashboard', user.organisation?._id),
          isOrgPrimaryAdmin: util.isInRole(user, 'org.managePermissions', user.organisation?._id),
          groupCount: user.groups?.length || 0,
          groupLeaderCount: user.roles ? Object.keys(user.roles).filter((id) => util.isGroupLeader(user, { id })).length : 0,
          ideaCount: user.ideaCount,
        },
      });
    }
    if (!user) {
      shutdownIntercom();
    }
  }, [user, bootIntercom, shutdownIntercom]);
};

export default useIntercom;
